/**
 * Métricas de casa e historial (§11.1 "Historial & Casa").
 */
import { z } from 'zod';
import { CentsWireSchema } from '../money.js';
import { FightSchema } from './fight.js';

export const HouseMetricsSchema = z.object({
  fightCount: z.number().int().nonnegative(),
  settledFightCount: z.number().int().nonnegative(),
  cancelledFightCount: z.number().int().nonnegative(),
  betCount: z.number().int().nonnegative(),
  totalVolumeCents: CentsWireSchema,
  totalRakeCents: CentsWireSchema,
  totalPaidCents: CentsWireSchema,
  totalRefundedCents: CentsWireSchema,
  totalVoidedCents: CentsWireSchema,
  /** Ganancia neta de casa = rake − escrow consumido − déficits de piso. */
  netHouseCents: z.number().int(),
  pendingPayoutCents: CentsWireSchema,
  pendingPayoutCount: z.number().int().nonnegative(),
  avgBetCents: CentsWireSchema,
  largestBetCents: CentsWireSchema,
  byDay: z.array(
    z.object({
      day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
      volumeCents: CentsWireSchema,
      rakeCents: CentsWireSchema,
      betCount: z.number().int().nonnegative(),
    }),
  ),
});
export type HouseMetrics = z.infer<typeof HouseMetricsSchema>;

export const ArchivedFightSchema = FightSchema.pick({
  id: true,
  title: true,
  redFighter: true,
  blueFighter: true,
  status: true,
  winner: true,
  finalMetrics: true,
  createdAt: true,
  settledAt: true,
  cancelledAt: true,
  rulesSnapshot: true,
});
export type ArchivedFight = z.infer<typeof ArchivedFightSchema>;
